import { Button, Text } from "@softmax/design-system";
import { spacing } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import { useRef } from "react";

export function PlayerPhotoUpload({
  name,
  avatarUrl,
  disabled,
  onUploadAvatar,
}: {
  readonly name: string;
  readonly avatarUrl: string | null;
  readonly disabled: boolean;
  readonly onUploadAvatar: (file: File) => void;
}) {
  const input = useRef<HTMLInputElement>(null);
  return (
    <div {...stylex.props(styles.upload)}>
      <div>
        <Button
          size="sm"
          disabled={disabled}
          onClick={() => input.current?.click()}
          aria-label={`Upload photo for ${name}`}
        >
          {avatarUrl ? "Change player photo" : "Upload player photo"}
        </Button>
      </div>
      <input
        ref={input}
        aria-label={`Photo file for ${name}`}
        type="file"
        accept="image/png,image/jpeg,image/webp,image/gif"
        disabled={disabled}
        onChange={(event) => {
          const file = event.target.files?.[0];

          if (file) onUploadAvatar(file);

          event.target.value = "";
        }}
        {...stylex.props(styles.hidden)}
      />
      <Text as="p" size="small" tone="muted">
        PNG, JPEG, WebP, or GIF. Maximum 5 MB.
      </Text>
    </div>
  );
}
const styles = stylex.create({
  upload: { display: "grid", gap: spacing.space8 },
  hidden: { display: "none" },
});
